import CachedResourceStore from '@/store/modules/CachedResourceStore'
import { Invoice } from '@/models/accounting/Invoice'
export default new CachedResourceStore<Invoice>(Invoice, {
	namespaced: true
})
